const rules = {
  lastName: {
    required: '入力してください'
  },
  firstName: {
    required: '入力してください'
  },
  lastNameKana: {
    required: '入力してください',
    kana: 'ひらがな・カタカナで入力してください'
  },
  firstNameKana: {
    required: '入力してください',
    kana: 'ひらがな・カタカナで入力してください'
  },
  gender: {
    required: '選択してください'
  },
  year: {
    required: '「年」を入力してください',
    year: '正しい「年」を入力してください',
  },
  month: {
    required: '「月」を入力してください',
    month: '正しい「月」を入力してください'
  },
  day: {
    required: '「日」を入力してください',
    day: '正しい「日」を入力してください',
    birthIsDate: '正しい生年月日を入力してください'
  },
  tel: {
    required: '入力してください',
    tel: '正しい電話番号を入力してください'
  },
  email: {
    required: '入力してください',
    mail: '正しいメールアドレスを入力してください'
  }
};



const group = {
  fullName    : 'lastName firstName',
  fullNameKana: 'lastNameKana firstNameKana',
  address     : 'zip locality street',
  birth       : 'year month day'
};



const method = {
  birthIsDate: function(value, element, params){
    const y = vivaForm.year.value, m = vivaForm.month.value, d = vivaForm.day.value;
    if( y && m && d ){
      const date = new Date( y, m -1, d );
      const month = date.getMonth() + 1;
      return Number(m) === month;
    }
  }
};



vivaForm({
  formname: 'vivaForm',
  rules: rules,
  group: group,
  method: method
});
